import { ExpedienteDto } from '.'
import { UserExpedienteRepository } from '@/Domain/Expediente/UserExpedienteRepository'
import { FetchDetailsExpedienteCommand } from './FetchDetailsExpedienteCommand'

export class FetchDetailsExpedienteCommandHandler {
  private _expedienteRepository: UserExpedienteRepository
  constructor (
    expedienteRepository: UserExpedienteRepository
  ) {
    this._expedienteRepository = expedienteRepository
  }

  async handle (command: FetchDetailsExpedienteCommand): Promise<ExpedienteDto> {
    const referenciaExp = command.referencia()
    const expediente = await this._expedienteRepository.byNumReferencia(referenciaExp)
    const response: ExpedienteDto = ExpedienteDto.fromExpediente(expediente)
    return response
  }
}
